// extracted by css-extract-rspack-plugin
export default {"article":"_794b7dad","title":"_b36c99a9"};